import { Select } from "../../UI/Select";
import { SelectWrapper } from "../../components/SelectWrapper";


export const MatchingRoundStatusSelector = ({
  value,
  onChange,
  isMulti = false,
  label = "Matching Round Status",
  id = "matching-round-status-select",
  isSearchable = true,
  isDisabled = false,
  resetDeps = [],
}) => {
  const options = ["MATCHING", "ACTIVE", "UPCOMING", "CLOSED", "ARCHIVED"].map((el) => ({label: el, value: el}));

  return (
  <SelectWrapper>
    <Select
      label={label}
      id={id}
      value={value}
      isMulti={isMulti}
      onChange={onChange}
      options={options}
      isSearchable={isSearchable}
      isDisabled={isDisabled}
      resetDeps={resetDeps}
    />
  </SelectWrapper>);
};